var map = {
	"./company/reducer.js": 1341,
	"./entities/reducer.js": 1342,
	"./filter/reducer.js": 1344,
	"./focus/reducer.js": 1543,
	"./lang/reducer.js": 1544,
	"./market/reducer.js": 1545,
	"./modal/reducer.js": 1546,
	"./reservation/reducer.js": 1547,
	"./resource/reducer.js": 1553
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;


//////////////////
// WEBPACK FOOTER
// ./src/store \.\/.+\/reducer\.js$
// module id = 1340
// module chunks = 0